import { useParams } from "react-router-dom";
import { getLocalStorageData } from "../../utils/LocalStorageService";
import { useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import { ACTION_TYPE, REPORT_NAME, REPORT_PATH } from "../constant/reportType";
import { Button, Form } from "react-bootstrap";
import { Switch, Table } from "antd";
import { BsPencilSquare, BsPlus, BsSearch } from "react-icons/bs";
import { useAppSelector } from "../../redux-toolkit/hooks";
import Loading from "../Loading";
import { alertMessage } from "../../utils/AlertService";
import { OPENING_FINANCE_COLUMNS, OPENING_KARMA_COLUMNS } from "../constant/AppConstant";
import { useDeleteOpeningBalanceFinanceMutation, useGetAllOpeningBalanceFinanceMutation, useSearchOpeningBalanceFinanceMutation } from "../../redux-toolkit/services/openingBalanceFinanceService";
import { useDeleteOpeningBalanceKarmaMutation, useGetAllOpeningBalanceKarmaMutation, useSearchOpeningBalanceKarmaMutation } from "../../redux-toolkit/services/openingBalanceKarmaService";
import { getOpeningBalanceFinanceBySearch, getOpeningBalanceFinanceData, getOpeningBalanceFinanceTotalRecords, setOpeningBalanceFinance, setOpeningBalanceFinanceBySearch } from "../../redux-toolkit/slices/openingBalanceFinanceSlice";
import { getOpeningBalanceKarmaBySearch, getOpeningBalanceKarmaData, getOpeningBalanceKarmaTotalRecords, setOpeningBalanceKarma, setOpeningBalanceKarmaBySearch } from "../../redux-toolkit/slices/openingBalanceKarmaSlice";
import OpeningBalanceReportsData from "./OpeningBalanceReportsData";
import { useSaveAuditLogMutation } from "../../redux-toolkit/services/auditLogService";

type Props = {};
const OpeningBalanceReports = (props: Props) => {

    const params = useParams();
    const localUserObj: any = getLocalStorageData("localUser");
    const token: any = getLocalStorageData("localUser").token;
    const dispatch = useDispatch();

    //state
    const [actionType, setActionType] = useState(ACTION_TYPE.ADD_ACTION) as any;
    const [reportName, setReportName]: any = useState();
    const [currentpage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [show, setShow] = useState(false);
    const [selectedRow, setSelectedRow]: any = useState([]);
    const [columData, setColumnData]: any = useState();
    const [dataSource, setDatasource]: any = useState([]);
    const [call, setCall] = useState("N");

    // getMutations
    const [getAllOpeningBalanceFinanceWithPagination, getAllOpeningBalanceFinanceWithPaginationResponse] = useGetAllOpeningBalanceFinanceMutation();
    const [getAllOpeningBalanceKarmaWithPagination, getAllOpeningBalanceKarmaWithPaginationResponse] = useGetAllOpeningBalanceKarmaMutation();

    // get by search
    const [searchOpeningBalanceFinance, searchOpeningBalanceFinanceResponse] = useSearchOpeningBalanceFinanceMutation();
    const [searchOpeningBalanceKarma, searchOpeningBalanceKarmaResponse] = useSearchOpeningBalanceKarmaMutation();

    // delete mutation
    const [deleteOpeningBalanceFinance, deleteOpeningBalanceFinanceResponse] = useDeleteOpeningBalanceFinanceMutation();
    const [deleteOpeningBalanceKarma, deleteOpeningBalanceKarmaResponse] = useDeleteOpeningBalanceKarmaMutation();

    //save
    const [logAudit] = useSaveAuditLogMutation();

    // totalRecords
    const totalOpeningBalanceFinance: any = useAppSelector(getOpeningBalanceFinanceTotalRecords);
    const totalOpeningBalanceKarma: any = useAppSelector(getOpeningBalanceKarmaTotalRecords);

    // selectors
    const openingBalanceFinanceSearchData: any = useAppSelector(getOpeningBalanceFinanceBySearch);
    const openingBalanceFinanceData: any = useAppSelector(getOpeningBalanceFinanceData);
    const openingBalanceKarmaSearchData: any = useAppSelector(getOpeningBalanceKarmaBySearch);
    const openingBalanceKarmaData: any = useAppSelector(getOpeningBalanceKarmaData);


    useEffect(() => {
        switch (params.reportType) {
            case REPORT_PATH.OPENING_BALANCE_MASTER_FINANCE:
                setReportName(REPORT_NAME.OPENING_BALANCE_MASTER_FINANCE)
                break;
            case REPORT_PATH.OPENING_BALANCE_MASTER_KARMA:
                setReportName(REPORT_NAME.OPENING_BALANCE_MASTER_KARMA)
                break;
            default:
        }
    }, [params.reportType]);



    useEffect(() => {
        const temp: any = [];
        const tempAction: any = {
            title: "Action",
            dataIndex: "action",
            key: "name",
            fixed: "right",
            width: 120,
            render: (index: any, record: any) => {
                return (
                    // for delete switch button
                    <div className="d-flex justify-content-between">
                        <div className="px-2 pe-auto">
                            <Switch
                                className={`${record.status === true ||
                                    record.enabled === true ||
                                    record.isActive === true ? "bg-accent" : "bg-secondry"}`}
                                checked={
                                    record.status === true ||
                                        record.enabled === true ||
                                        record.isActive === true
                                        ? true
                                        : false
                                }
                                onClick={() => {
                                    onDeleteData(record);
                                }}
                            />
                        </div>
                        {record.status === true ||
                            record.enabled === true ||
                            record.isActive === true ? (
                            <div
                                className="px-2 pe-auto"
                                onClick={() => {
                                    handleOpenForm(record);
                                }}
                            >
                                <BsPencilSquare size={18} />
                            </div>
                        ) : null}
                    </div>
                );
            },
        };

        if (reportName === REPORT_NAME.OPENING_BALANCE_MASTER_FINANCE && OPENING_FINANCE_COLUMNS) {
            OPENING_FINANCE_COLUMNS.map((item: any) => {
                temp.push(item);
            });
            temp.push(tempAction);
            setColumnData(temp);
        } else if (reportName === REPORT_NAME.OPENING_BALANCE_MASTER_KARMA && OPENING_KARMA_COLUMNS) {
            OPENING_KARMA_COLUMNS.map((item: any) => {
                temp.push(item);
            });
            temp.push(tempAction);
            setColumnData(temp);
        }
    }, [reportName, params.reportType]);

    useEffect(() => {
        if (reportName === REPORT_NAME.OPENING_BALANCE_MASTER_FINANCE) {
            getAllOpeningBalanceFinanceWithPagination({
                token: token,
                payload: {
                    size: pageSize,
                    page: currentpage - 1,
                    orderBy: "desc"
                }
            });
        } else if (reportName === REPORT_NAME.OPENING_BALANCE_MASTER_KARMA) {
            getAllOpeningBalanceKarmaWithPagination({
                token: token,
                payload: {
                    size: pageSize,
                    page: currentpage - 1,
                    orderBy: "desc"
                }
            });
        }
    }, [reportName]);


    useEffect(() => {
        if (call === "Y") {
            if (reportName === REPORT_NAME.OPENING_BALANCE_MASTER_FINANCE) {
                getAllOpeningBalanceFinanceWithPagination({
                    token,
                    payload: { size: pageSize, page: currentpage - 1, orderBy: "asc" }
                });
            } else if (reportName === REPORT_NAME.OPENING_BALANCE_MASTER_KARMA) {
                getAllOpeningBalanceKarmaWithPagination({
                    token,
                    payload: { size: pageSize, page: currentpage - 1, orderBy: "asc" }
                });
            }
            setCall("N");
        }
    }, [call]);


    const paginationChange = (page: number, pageSize: number) => {
        if (reportName === REPORT_NAME.OPENING_BALANCE_MASTER_FINANCE) {
            getAllOpeningBalanceFinanceWithPagination({
                token: token,
                payload: {
                    size: pageSize,
                    page: page - 1,
                    orderBy: "asc"
                }
            });
        } else if (reportName === REPORT_NAME.OPENING_BALANCE_MASTER_KARMA) {
            getAllOpeningBalanceKarmaWithPagination({
                token: token,
                payload: {
                    size: pageSize,
                    page: page - 1,
                    orderBy: "asc"
                }
            });
        }

        setCurrentPage(page);
        setPageSize(pageSize);
    };

    const handleShow = () => {
        setActionType(ACTION_TYPE.ADD_ACTION);
        setShow(true)
    };


    const onDeleteData = (record: any) => {
        if (reportName === REPORT_NAME.OPENING_BALANCE_MASTER_FINANCE) {
            deleteOpeningBalanceFinance({
                id: record.id,
                token: token,
            });

            const payload = {
                tableName: REPORT_NAME.OPENING_BALANCE_MASTER_FINANCE,
                recordId: record.id,
                operationType: "DELETE",
                oldValue: record,
                newValue: { ...record, isActive: !record.isActive },
            };

            logAudit({
                token: localUserObj?.token,
                payload: payload,
            });

        } else if (reportName === REPORT_NAME.OPENING_BALANCE_MASTER_KARMA) {
            deleteOpeningBalanceKarma({
                id: record.id,
                token: token,
            });

            const payload = {
                tableName: REPORT_NAME.OPENING_BALANCE_MASTER_KARMA,
                recordId: record.id,
                operationType: "DELETE",
                oldValue: record,
                newValue: { ...record, isActive: !record.isActive },
            };

            logAudit({
                token: localUserObj?.token,
                payload: payload,
            });
        }
    };



    // OPENING BALANCE - FINANCE
    useEffect(() => {
        if (deleteOpeningBalanceFinanceResponse.isSuccess) {
            if (deleteOpeningBalanceFinanceResponse.data?.isActive) {
                alertMessage("Opening Balance - Finance enabled successfully", "success");
            } else {
                alertMessage("Opening Balance - Finance deleted successfully", "success");
            }
            setCall("Y");
        } else if (deleteOpeningBalanceFinanceResponse.isError) {
            alertMessage("Error while deleting Opening Balance - Finance", "error");
        }
    }, [
        deleteOpeningBalanceFinanceResponse.isSuccess,
        deleteOpeningBalanceFinanceResponse.isError,
    ]);

    // OPENING BALANCE - KARMA
    useEffect(() => {
        if (deleteOpeningBalanceKarmaResponse.isSuccess) {
            if (deleteOpeningBalanceKarmaResponse.data?.isActive) {
                alertMessage("Opening Balance - Karma enabled successfully", "success");
            } else {
                alertMessage("Opening Balance - Karma deleted successfully", "success");
            }
            setCall("Y");
        } else if (deleteOpeningBalanceKarmaResponse.isError) {
            alertMessage("Error while deleting Opening Balance - Karma", "error");
        }
    }, [
        deleteOpeningBalanceKarmaResponse.isSuccess,
        deleteOpeningBalanceKarmaResponse.isError,
    ]);


    const handleOpenForm = (record: any) => {
        setActionType(ACTION_TYPE.UPDATE_ACTION);
        setSelectedRow(record);
        setShow(true);
    };

    const handleSearch = (event: any) => {
        if (reportName === REPORT_NAME.OPENING_BALANCE_MASTER_FINANCE) {
            searchOpeningBalanceFinance({
                token: localUserObj?.token,
                payload: { offset: 1000, pageNumber: 0, searchBy: event.target.value },
            });
        } else if (reportName === REPORT_NAME.OPENING_BALANCE_MASTER_KARMA) {
            searchOpeningBalanceKarma({
                token: localUserObj?.token,
                payload: { offset: 1000, pageNumber: 0, searchBy: event.target.value },
            });
        }
    };



    useEffect(() => {
        if (searchOpeningBalanceFinanceResponse.isSuccess) {
            dispatch(setOpeningBalanceFinanceBySearch(searchOpeningBalanceFinanceResponse));
        } else if (searchOpeningBalanceFinanceResponse.isError) {
            let response: any = searchOpeningBalanceFinanceResponse.error;
            alertMessage(response, "error");
        }
    }, [searchOpeningBalanceFinanceResponse.isSuccess, searchOpeningBalanceFinanceResponse.isError]);

    useEffect(() => {
        if (searchOpeningBalanceKarmaResponse.isSuccess) {
            dispatch(setOpeningBalanceKarmaBySearch(searchOpeningBalanceKarmaResponse));
        } else if (searchOpeningBalanceKarmaResponse.isError) {
            let response: any = searchOpeningBalanceKarmaResponse.error;
            alertMessage(response, "error");
        }
    }, [searchOpeningBalanceKarmaResponse.isSuccess, searchOpeningBalanceKarmaResponse.isError]);


    useEffect(() => {
        if (getAllOpeningBalanceKarmaWithPaginationResponse.isSuccess) {
            dispatch(setOpeningBalanceKarma(getAllOpeningBalanceKarmaWithPaginationResponse));
        } else if (getAllOpeningBalanceKarmaWithPaginationResponse.isError) {
            let response: any = getAllOpeningBalanceKarmaWithPaginationResponse.error;
            alertMessage(response, "error");
        }
    }, [getAllOpeningBalanceKarmaWithPaginationResponse.isSuccess, getAllOpeningBalanceKarmaWithPaginationResponse.isError]);

    useEffect(() => {
        if (getAllOpeningBalanceFinanceWithPaginationResponse.isSuccess) {
            dispatch(setOpeningBalanceFinance(getAllOpeningBalanceFinanceWithPaginationResponse));
        } else if (getAllOpeningBalanceFinanceWithPaginationResponse.isError) {
            let response: any = getAllOpeningBalanceFinanceWithPaginationResponse.error;
            alertMessage(response, "error");
        }
    }, [getAllOpeningBalanceFinanceWithPaginationResponse.isSuccess, getAllOpeningBalanceFinanceWithPaginationResponse.isError]);


    useEffect(() => {
        if (openingBalanceFinanceSearchData && reportName === REPORT_NAME.OPENING_BALANCE_MASTER_FINANCE) {
            setDatasource(openingBalanceFinanceSearchData);
        }
    }, [openingBalanceFinanceSearchData]);

    useEffect(() => {
        if (openingBalanceKarmaSearchData && reportName === REPORT_NAME.OPENING_BALANCE_MASTER_KARMA) {
            setDatasource(openingBalanceKarmaSearchData);
        }
    }, [openingBalanceKarmaSearchData]);



    useEffect(() => {
        if (openingBalanceFinanceData && reportName === REPORT_NAME.OPENING_BALANCE_MASTER_FINANCE) {
            setDatasource(openingBalanceFinanceData);
        }
    }, [openingBalanceFinanceData]);



    useEffect(() => {
        if (openingBalanceKarmaData && reportName === REPORT_NAME.OPENING_BALANCE_MASTER_KARMA) {
            setDatasource(openingBalanceKarmaData);
        }
    }, [openingBalanceKarmaData]);


    return (
        <div className="mt-2 overflow-y-auto">
            <div className="d-flex align-items-center justify-content-between flex-sm-row flex-column mb-2">
                <div className="d-flex align-items-center w-100 px-2">
                    <h5
                        className="m-0 px-0 d-flex align-items-center text-accent"
                        style={{ fontWeight: "700" }}
                    >
                        {reportName}
                    </h5>
                </div>
                <div className="d-flex align-items-center justify-content-start justify-content-sm-end cursor-pointer w-100">
                    <div className="d-flex flex-column">
                        <div className="input-group px-2 mt-1">
                            <Form.Control
                                type="search"
                                placeholder="Search"
                                className="border-0 bg-cm-light-primary1"
                                aria-label="Search"
                                onChange={handleSearch}
                            />
                            <div className="input-group-append bg-cm-light-primary1 p-1 rounded-end">
                                <span className="input-group-text bg-cm-light-primary1 border-0">
                                    {/* <img src={gear} alt="" /> */}
                                    <BsSearch className=" bg-cm-light-primary1 border-cm-light-primary1" />
                                </span>
                            </div>
                        </div>
                    </div>
                    <div onClick={handleShow} className="d-flex px-2 align-items-center mt-1">
                        <Button
                            className="d-flex align-items-center me-0 text-nowrap bg-accent"
                        // onClick={() => {
                        //     setActionType(ACTION_TYPE.ADD_ACTION);
                        // }}
                        >
                            <BsPlus />
                            Add
                        </Button>
                    </div>
                    {
                        getAllOpeningBalanceFinanceWithPaginationResponse.isLoading ||
                            getAllOpeningBalanceKarmaWithPaginationResponse.isLoading ||
                            searchOpeningBalanceFinanceResponse.isLoading ||
                            searchOpeningBalanceKarmaResponse.isLoading ||
                            deleteOpeningBalanceFinanceResponse.isLoading ||
                            deleteOpeningBalanceKarmaResponse.isLoading
                            ? (

                                <Loading />
                            ) : (
                                ""
                            )}
                    {show && (
                        <OpeningBalanceReportsData
                            show={show}
                            setShow={setShow}
                            actionType={actionType}
                            reportName={reportName}
                            data={selectedRow}
                            setCall={setCall}
                        />
                    )}
                </div>
            </div>
            <div className="mt-3 my-2 w-100 overflow-x-auto rounded-3">
                <Table
                    bordered={true}
                    rowKey={"id"}
                    pagination={{
                        total: (() => {
                            switch (reportName) {
                                case REPORT_NAME.OPENING_BALANCE_MASTER_FINANCE:
                                    return totalOpeningBalanceFinance;
                                case REPORT_NAME.OPENING_BALANCE_MASTER_KARMA:
                                    return totalOpeningBalanceKarma;
                                default:
                                    return [];
                            }
                        })(),
                        // hideOnSinglePage: true,  
                        responsive: true,
                        current: currentpage,
                        // showSizeChanger: true,  
                        pageSizeOptions: [10, 20, 30],
                        onChange: (page, pageSize) => {
                            paginationChange(page, pageSize);
                        },
                        pageSize: pageSize,
                    }}
                    columns={columData}
                    dataSource={dataSource}
                />
            </div>
        </div>
    );
};
export default OpeningBalanceReports;